import React from 'react';

import cls from '../DnD.module.css';

interface IAttachmentsProps<T> {
    attachments: T[];
    getFileName: (file: T) => string;
}

export const Attachments = <T,>({ attachments, getFileName }: IAttachmentsProps<T>) => {
    if (attachments.length === 0) {
        return null;
    }

    return (
        <ul className={cls.AttachmentsList}>
            {attachments.map((file) => (
                <li>{getFileName(file)}</li>
            ))}
        </ul>
    );
};
